import { AfterViewInit, ChangeDetectorRef, Component, computed, CUSTOM_ELEMENTS_SCHEMA, effect, ElementRef, OnDestroy, signal, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
// import { disconnect, switchNetwork, watchAccount, watchNetwork } from '@wagmi/core';
// import { createWeb3Modal, defaultWagmiConfig } from '@web3modal/wagmi';
import { ToastrService } from 'ngx-toastr';
import { firstValueFrom, interval, Observable, takeUntil } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { DistributionService } from '../../../modules/services/distribution.service';
import { AMCDistributionService } from '../../../modules/services/amc.service';
import { AuthService } from '../../services/auth.service';
import { ApiResponse, CheckAdmin, LoginResponse } from '../../services/types/api-schema.types';
import { DistributionModesDetails } from '../enums/enum';
import { LocalStorageService } from '../../services/local-storage.service';
import { WalletService } from '../../../modules/services/wallet.service';
import { ModalService } from '../../../modules/services/modal.service';
import { ConfirmationModalComponent } from '../confirmation-modal/confirmation-modal.component';
import { SidebarService } from '../../services/sidebar.service';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [ConfirmationModalComponent],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],

})
export class NavbarComponent implements AfterViewInit, OnDestroy {
  @ViewChild('navEl') private readonly navEl!: ElementRef<HTMLElement>;
  private navHeightObserver?: ResizeObserver;

  private supportedChains: any = environment.SUPPORTED_CHAINS;
  protected chainId = environment.CHAIN_ID;
  connectorInfo: any;
  protected distributionMode!: string;
  protected isChecked: boolean = false;
  protected distributionId!: string;
  protected walletAddress = signal<string>(''); // Signal to store wallet address
  listenWalletAddress = computed(()=> this.authService.address()); // Signal to listen for changes in wallet address
  protected showSignOutModal = signal<boolean>(false);
  protected isSigningOut = signal<boolean>(false);

  isConnected: boolean = false;
    networkName: string = '';
  constructor(
    private readonly authService: AuthService,
    private readonly router: Router,
    private readonly toast: ToastrService,
    private readonly distributionService: DistributionService,
    private readonly amcDistributionService: AMCDistributionService,
    private readonly localStorageService: LocalStorageService,
    private walletService: WalletService,
    private modalService: ModalService,
    private cdr: ChangeDetectorRef,
    private sidebarService: SidebarService,

  ) { }

  ngOnInit() {
    this.getDistributionMode();

      this.walletService.account$.subscribe((account) => {
        console.log('account observable', account);
        this.isConnected = !!account?.isConnected;
        this.walletAddress.set( account?.address || '');
        this.networkName = account?.chainId !== undefined ? this.getNetworkName(account.chainId) : '';
        if (this.walletAddress()) {
          this.checkAdmin(this.walletAddress());
        }
        console.log('chainId', this.networkName);
        this.cdr.detectChanges(); // Manually trigger change detection
      });

      this.walletService.loading$.subscribe((loading) => {
        this.isSigningOut.set(loading && this.showSignOutModal());
      });
  
      console.log('---', this.isConnected, this.networkName, this.walletAddress);
    // this.wagmiConfiguration();

  }

  /**
   * Publishes the navbar's real rendered height as a CSS custom property
   * (--navbar-height) so the mobile sidebar drawer (a fixed element that
   * must start below the navbar) can size itself against the actual height
   * instead of a guessed padding value. Needed because the navbar's right-side
   * controls wrap onto a second line on narrow viewports, so its height isn't
   * a fixed constant - a hardcoded offset works at some widths and silently
   * hides content under the navbar at others.
   */
  ngAfterViewInit(): void {
    const updateHeight = () => {
      const height = this.navEl.nativeElement.offsetHeight;
      document.documentElement.style.setProperty('--navbar-height', `${height}px`);
    };

    this.navHeightObserver = new ResizeObserver(updateHeight);
    this.navHeightObserver.observe(this.navEl.nativeElement);
    updateHeight();
  }

  ngOnDestroy(): void {
    this.navHeightObserver?.disconnect();
  }

  /**
   * Signs out
   */
  // signOut() {
  //   this.authService.signOut().subscribe({
  //     next: (response: ApiResponse<LoginResponse>) => {
  //       this.toast.success(response.message);
  //       disconnect();
  //       this.authService.removeToken();
  //       this.localStorageService.clearAllStorage();
  //       this.router.navigate(['/']);
  //     },
  //     error: (error: any) => {
  //     }
  //   })
   
  // }

  // /**
  //  * Initializes wagmi configuration
  //  *
  //  * The function initializes the wagmi configuration and sets up event listeners for
  //  * changes in the wallet account and network. When the account changes, it updates
  //  * the wallet address signal and when the network changes, it checks if the network
  //  * is unsupported and if so, it displays an error message and switches the network.
  //  */
  // public wagmiConfiguration() {
  
  //   const chains = this.supportedChains;
  //   const projectId = environment.WALLET_CONNECT_PROJECT_ID;

  //   // Create a metadata object
  //   const metadata = {
  //     name: 'AOC',
  //     description: 'USDT Over Liquidity Contribution',
  //     url: 'https://web3.alphaomegacoin.com', // origin must match your domain & subdomain
  //     icons: ['https://avatars.githubusercontent.com/u/37784886']
  //   }

  //   const config = defaultWagmiConfig({ chains, projectId, metadata })

  //   const modal = createWeb3Modal({
  //     wagmiConfig: config,
  //     projectId,
  //     themeMode: 'light',
  //     enableAnalytics: true,
  //     themeVariables: {
  //       '--w3m-accent': '#D4AE36'
  //     }
  //   })

  //   watchAccount(async (account) => {
  //     // Create an observable that emits at a 10ms interval until the wagmi store is updated
  //     const wagmiStore$ = interval(10).pipe(
  //       takeUntil(
  //         new Observable(observer => {
  //           // Check if the wagmi store has the user's account address
  //           const wagmiStore = JSON.parse(localStorage.getItem('wagmi.store') || '{}');      
  //           if (wagmiStore.state?.data?.account == account.address) {
  //             observer.next(true);
  //             observer.complete();
  //           }
  //         })
  //       )
  //     );
  //     // Wait for the first value from the observable, or null if it completes without emitting
  //     await firstValueFrom(wagmiStore$, { defaultValue: null });
  //     // Get the wagmi store from local storage and parse it as JSON
  //     const wagmiStore: any = localStorage.getItem('wagmi.store');
  //     const wagmiAccount = JSON.parse(wagmiStore);
  //     this.walletAddress = wagmiAccount?.state?.data?.account || '';
  //     // Update the connector info with the user's account address
  //     this.connectorInfo = wagmiAccount?.state?.data?.account;
  //   });

  //   watchNetwork(async (network) => {
  //     if (network.chain?.unsupported == true) {
  //       this.toast.error('Wrong network connected');
  //       this.switchNetwork();
  //     }
  //   });    
  // }

  // /**
  //  * Switchs network
  //  */
  // public async switchNetwork() {
  //   switchNetwork({
  //     chainId: this.chainId
  //   }).then(() => {
  //     this.checkAdminExists(this.connectorInfo.account);

  //   });
  // }

  /**
   * Fetches the current distribution mode and sets the component state accordingly.
   * It also stores the distribution id in the component state.
   * If the request fails, it shows an error message in a toast.
   */
  getDistributionMode() {
    this.distributionService.getDistributionMode().subscribe({
      next: (response : ApiResponse<any>) => {
        const distType = Number(response.data.distribution_type);
        this.isChecked = distType === DistributionModesDetails.AUTOMATED_CODE;
        this.distributionMode = this.isChecked ? DistributionModesDetails.AUTOMATED : DistributionModesDetails.MANUAL;
        localStorage.setItem('distributionType', String(distType));
        this.distributionService.setDistributionType(distType);
        this.amcDistributionService.setDistributionType(distType);
        this.distributionId = response.data._id;
        this.cdr.detectChanges();
      },
      error: (error) => {
        this.toast.error('Something went wrong. Please try again.');
      }
    });
  }


  /**
   * Toggles the distribution mode between automated and manual.
   * 
   * This function flips the `isChecked` state, which determines the current distribution mode.
   * Based on the new state, it updates the `distributionMode` property and makes an API call
   * to update the backend with the new mode code.
   */
  onDistributionModeChange() {
    this.isChecked = !this.isChecked;

    // Determine the mode based on the current 'isChecked' state
    const modeCode = this.isChecked ? DistributionModesDetails.AUTOMATED_CODE : DistributionModesDetails.MANUAL_CODE;

    // Toggle the isChecked state and set distributionMode accordingly
    this.distributionMode = this.isChecked ? DistributionModesDetails.AUTOMATED : DistributionModesDetails.MANUAL;

    // Make the API call to update the backend
    this.distributionService.updateDistributionMode(modeCode, this.distributionId).subscribe({
      next: (response: ApiResponse<any>) => {
        const distType = Number(response.data.distribution_type);
        localStorage.setItem('distributionType', String(distType));
        this.distributionService.setDistributionType(distType);
        this.amcDistributionService.setDistributionType(distType);

        console.log('distribution mode changed');
        
      },
      error: (error) => {
        console.log(error);
      }
    });
  }


    /**
   * Checks admin exists
   * @param walletAddress 
  //  */
  //   checkAdminExists(walletAddress: string) {
  //     this.authService.checkValidAdmin(walletAddress).subscribe({
  //       next: (response: ApiResponse<CheckAdmin>) => {
  //         if (response && this.chainId) {
  //           this.loginAdmin(response.data.wallet_address);
  //         }
  //       },
  //       error: (error) => {
  //         this.toast.error(error.error.message);
  //         disconnect();
  //       },
  //     });
  //   }

  //    /**
  //  * Logins admin
  //  * @param walletAddress 
  //  */
  // loginAdmin(walletAddress: string) {
  //   this.authService.adminLogin(walletAddress).subscribe({
  //     next: (response: ApiResponse<LoginResponse>) => {
  //       this.toast.success('Admin LoggedIn Successfully');
  //       this.authService.setToken(response.data.session.session_token);
  //     },
  //   });
  // }

  /**
   * Truncates a string to show only the first 4 and last 6 characters.
   * @param address The address to truncate.
   * @returns The truncated address.
   */
  sliceAddress(address: string): string {
    if (address && address.length > 10) {
      const firstFour = address.slice(0, 4); 
      const lastSix = address.slice(-6); 
      return `${firstFour}...${lastSix}`; 
    }
    return address;
  }

  /**
   * Copies the given address to the clipboard.
   * @param address The address to be copied.
   */
  copyAddress(address: string): void {
    const textArea = document.createElement('textarea');
    textArea.value = address; 
    document.body.appendChild(textArea)
    textArea.select(); 
    document.execCommand('copy'); 
    document.body.removeChild(textArea); 
    this.toast.success('Address copied to clipboard');
  }

  /**
   * Retrieves the network name based on the chain ID.
   *
   * This helper method takes a `chainId` as input and returns the corresponding
   * network name. It uses a predefined mapping of chain IDs to network names.
   * If the chain ID is not recognized, it returns 'Unsupported Network'.
   *
   * @param chainId - The chain ID for which to retrieve the network name.
   * @returns The network name corresponding to the given chain ID.
   */
   private getNetworkName(chainId: number): string {
    const networks: { [key: number]: string } = {
      56: 'Binance Smart Chain',
      97: 'Binance Smart Chain Testnet',
      // Add more networks as needed
    };
    return networks[chainId] || 'Unsupported Network';
  }

   /**
   * Disconnects the wallet from MetaMask.
   *
   * This method calls the `disconnectWallet` method from the `WalletService`
   * to initiate the disconnection process for the currently connected wallet.
   * It is typically triggered by a user action, such as clicking a disconnect
   * button in the UI.
   */
  openSignOutModal() {
    this.showSignOutModal.set(true);
  }

  closeSignOutModal() {
    if (this.isSigningOut()) {
      return;
    }
    this.showSignOutModal.set(false);
  }

  disconnectMetamask() {
    this.walletService.disconnectWallet();
  }

  /**
   * Opens a modal dialog.
   *
   * This method uses the `ModalService` to open a modal dialog with the ID
   * 'crypto-modal'. It is typically triggered by a user action, such as
   * clicking a button to open the modal.
   */
  openModal(): void {
    this.modalService.open('crypto-modal');
  }

  /**
   * Toggles the mobile/tablet sidebar drawer (hidden above the lg breakpoint,
   * where the sidebar is always visible regardless of this state).
   */
  toggleSidebar(): void {
    this.sidebarService.toggle();
  }

  /**
   * Checks if the given wallet address is a valid admin, and logs them in if so.
   *
   * If the wallet address is valid, it logs the admin in by calling the
   * `loginAdmin` method from the `WalletService` with the given wallet address.
   * If the wallet address is invalid, it navigates to the root route and clears
   * all local storage.
   *
   * @param walletAddress - The wallet address to check.
   */
  checkAdmin(walletAddress: string) {
     this.authService.checkValidAdmin(walletAddress).subscribe({
          next: (response: ApiResponse<CheckAdmin>) => {
            console.log('Admin verified:', response.data.wallet_address);
          },
          error: (error: any) => {
            this.router.navigate(['/']);
            this.localStorageService.clearAllStorage();          
          }
        })
  }
}
